import clsx from 'clsx';
import {
  TwitterShareButton,
  TwitterIcon,
  LineShareButton,
  LineIcon,
  FacebookShareButton,
  FacebookIcon,
} from 'react-share';

const sizes = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
  xl: 'h-14 w-14',
};

export type SocialShareProps = {
  size?: keyof typeof sizes;
  className?: string;
};

const url = 'https://kankin-jk.web.app/april';

export const SocialShare = ({ size = 'md', className = '' }: SocialShareProps) => {
  const sharedClassName = clsx(
    sizes[size],
    'transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110',
    className
  );
  return (
    <div className="opacity-80">
      <TwitterShareButton url={url} hashtags={['監禁JK', 'エイプリルフール']}>
        <TwitterIcon
          className={sharedClassName}
          round
          bgStyle={{
            fill: 'transparent',
          }}
          iconFillColor="white"
        />
      </TwitterShareButton>
      <LineShareButton url={url}>
        <LineIcon
          className={sharedClassName}
          bgStyle={{
            fill: 'transparent',
          }}
          round
          iconFillColor="white"
        />
      </LineShareButton>
      <FacebookShareButton url={url}>
        <FacebookIcon
          className={sharedClassName}
          bgStyle={{
            fill: 'transparent',
          }}
          round
          iconFillColor="white"
        />
      </FacebookShareButton>
    </div>
  );
};
